<template>
    <v-card class="ma-2 pa-3 d-flex justify-space-between align-center" outlined raised>
        <span><v-icon left color="primary">mdi-email</v-icon>{{ $translate('You have been invited to this activity') }}</span>
        <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
        <span v-else-if="hasResponded">
            <v-alert type="success">
                {{$translate('INVITATION_ANSWERED')}}
            </v-alert>
        </span>
        <span v-else>
            <v-btn text color="primary" class="zoezi-button-thin" @click="answerInvite(true)">{{ $translate('Accept') }}</v-btn>
            <v-btn text color="error" class="zoezi-button-thin" @click="answerInvite(false)">{{ $translate('Decline') }}</v-btn>
        </span>
    </v-card>
</template>

<script>
export default {
    name: 'Invite',

    props: {
        invite: {
            type: Object
        },
        workout: {
            type: Object
        }
    },

    watch: {
        invite: {
            immediate: true,
            handler() {
                this.hasResponded = this.invite.hasResponded;
            }
        }
    },

    data: () => ({
        hasResponded: false,
        loading: false
    }),

    methods: {
        answerInvite(answer) {
            this.loading = true;
            this.$api.post('/api/workoutBooking/invites/answer', {
                hash: this.invite.linkHash,
                accept: answer
            }).then((response) => {
                response.json().then(data => {
                    this.loading = false;

                    if (response.ok) {
                        this.hasResponded = true;
                    } else {
                        let text = this.$translate(data.message);
                        this.$store.commit('showSnackBar', {text});
                    }
                })
            }).catch(() => {
                this.loading = false;
            });
        }
    }
}
</script>
